import '../CssStykes/Profile.css'
export default function Contact(){
    return(
        <>
        <div className="about-body ">
    <div class="container">
        <h2>Contact</h2>

        <div class="contact-info">
            <h3>Contact Information</h3>
            <p>Phone: +91 9347779216</p>
            <p>Email: kammalaharish23@gmail.com</p>
        </div>

        <div class="home-address">
            <h3>Home Address</h3>
            <address >
                Village: Kalli Palli<br/>
                Mandal: Nallacheruvu<br/>
                Pincode: 515551<br/>
                State: Andhra Pradesh
            </address>
        </div>
    </div>
    </div>
        </>
    )
}